export default __webpack_public_path__ + "static/media/vert.8e23498c.jpg";